import * as defaultImport from "@splunk/react-ui/Modal";
export * from "@splunk/react-ui/Modal";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
